<div class="general-outside outside-container">
  <img class="background" alt="background image" fill [ngSrc]="backgroundImageUrl" />
  <div class="outside-box">
    <kendo-gridlayout #contents [gap]="{ rows: 5 }">
      <kendo-gridlayout-item #headerleft [col]="1" [row]="1">
        <a href="https://www.ahfc.us"><img class="outside-logo" src="logos/logo_white_sm.png" alt="ahfc logo" /></a>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item #headerright [col]="2" [row]="1">
        <kendo-stacklayout #titles orientation="vertical" [align]="{ horizontal: 'end' }">
          <span class="outside-subtitle">{{ $modalHeaderSubtitle() }}</span>
          <span class="outside-title">{{ $modalHeaderTitle() }}</span>
        </kendo-stacklayout>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item class="outside-content" [colSpan]="2" [row]="3">
        <ng-content>
          <!-- Content from subcomponents -->
        </ng-content>
      </kendo-gridlayout-item>
    </kendo-gridlayout>
  </div>
  <span class="lowright">{{ version.version }} ({{ version.commit }})</span>
</div>
